import { useContractInfoPaymentMethod } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractInfoPaymentMethodPresentation } from './presentations';

/**
 * ご契約情報 お支払い方法 Container
 *
 * 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ContractInfoPaymentMethod: React.FC = () => {
  const {
    state: { data },
  } = useContractInfoPaymentMethod();

  const { cardLabel } = convertToPresentationProps({ data });

  return <ContractInfoPaymentMethodPresentation cardLabel={cardLabel} />;
};
